import { useLocation as useRouterLocation } from 'react-router-dom';

export interface LocationState {
  returnTo?: string;
}

export const useLocation = () => {
  const location = useRouterLocation();
  return {
    ...location,
    state: location.state as LocationState | undefined,
    fullPath: location.pathname + location.search + location.hash,
  };
};
